import { motion } from "framer-motion";

const HEADER_ANIMATION_INITIAL = { opacity: 0, y: 8 };
const HEADER_ANIMATION_ANIMATE = { opacity: 1, y: 0 };
const HEADER_ANIMATION_TRANSITION = { duration: 0.35 };

export default function PageHeader({ eyebrow, title, subtitle, children }) {
  return (
    <motion.div
      initial={HEADER_ANIMATION_INITIAL}
      animate={HEADER_ANIMATION_ANIMATE}
      transition={HEADER_ANIMATION_TRANSITION}
      className="mb-10"
    >
      {eyebrow && (
        <div className="text-xs uppercase tracking-[0.2em] text-[#5B695E] mb-3">
          {eyebrow}
        </div>
      )}
      <div className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          <h1 className="font-heading text-4xl sm:text-5xl tracking-tight font-light text-[#111812]">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-3 text-[#5B695E] max-w-2xl leading-relaxed">{subtitle}</p>
          )}
        </div>
        {children && <div className="flex gap-3">{children}</div>}
      </div>
    </motion.div>
  );
}
